import { Grid, Tooltip, CardContent, CardHeader, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import React, { useContext } from "react";
import EyeBrow from "../../commonComponents/eyeBrow/eyeBrow";
import { AcknowledgeCardStyle } from "./acknowledgeCard.style";
import DefaultPC from "../../../assets/images/placeholder-pc.png";
import { ThemeContext } from 'styled-components';
import { TruncatedText } from "component/MarketPlace/Typography/Typography.style";
import { StyledTooltip } from "../pcCard/pcCard.style";
import { Button } from "component/MarketPlace/ButtonComponents";
import UptimeImage from "component/commonComponents/UptimeImage/UptimeImage";

export interface IAcknowledgeCardProps {
  acknowledgeDevice: any;
  locale: {
    desc_1: string;
    desc_2: string;
    serialNumber: string;
    lastScanned: string;
    acknowledgeBtn: string;
    commonStatus: any;
  };
  handleAcknowledge: () => Promise<void>;
  disableAcknowledgeButton: boolean;
};

const AcknowledgeCard = (props: IAcknowledgeCardProps) => {
  const theme = useContext(ThemeContext);
  const { acknowledgeDevice, locale, handleAcknowledge, disableAcknowledgeButton } = props;

  if (!acknowledgeDevice.model_picture)
    acknowledgeDevice.model_picture = DefaultPC;

  const hasEyebrow = !!acknowledgeDevice.process_stage.task_eyebrow ? true : false;

  const clearSelection = () => {
    const selection = window.getSelection();
    if (selection) {
      selection.empty();
    }
  };

  const handleClickAcknowledge = async () => {
    await handleAcknowledge();
  };

  return (
    <AcknowledgeCardStyle onDragStart={clearSelection}>
      <CardHeader
        className="uptime-acknowledge-card-header"
        title={hasEyebrow &&
          <EyeBrow
            color={theme.uptimeColors.deviceCardEyebrow.acknowledgeDevice.color}
            backgroundColor={theme.uptimeColors.deviceCardEyebrow.acknowledgeDevice.background}
            text={locale?.commonStatus[acknowledgeDevice.process_stage.task_eyebrow?.toUpperCase()]}
            id="chp-acknowledgecard-status"
          />
        }
      />
      <CardContent className="uptime-acknowledge-card-content">
        <Grid item container>
          <Grid item xs={12} className="uptime-acknowledge-card-content-image">
            <UptimeImage
              src={acknowledgeDevice.model_picture}
              alt="device"
              title={`${acknowledgeDevice.model} ${acknowledgeDevice.manufacturer} ${acknowledgeDevice.serial_number}`}
              width="100%"
              height={90}
              wrapperProps={{
                style: { objectFit: 'contain', backgroundSize: 'contain' }
              }}
            />
          </Grid>
          <Grid item xs={12} className="uptime-acknowledge-card-configuration">
            <Grid item xs={12}>
              <div className="uptime-acknowledge-card-deviceBrand">
                {locale?.desc_1}
              </div>
              <Tooltip title={locale?.desc_2} arrow placement="bottom-start">
                <div className="uptime-acknowledge-card-deviceName select-all-text">
                  {locale?.desc_2}
                </div>
              </Tooltip>
            </Grid>
            <Grid item xs={12}>
              <div className="uptime-acknowledge-card-configuration-item">
                <div>
                  {" "}
                  <LocalOfferIcon />
                </div>
                <Typography variant="body2" fontWeight={700} mr="8px" flexShrink={0} id="uptime-acknowledge-card-configuration-item-header">
                  {locale?.serialNumber}
                </Typography>
                <StyledTooltip title={acknowledgeDevice.serial_number} arrow>
                  <TruncatedText maxlines={1} variant="body2" className="uptime-acknowledge-card-configuration-item-content select-all-text" title={acknowledgeDevice.serial_number} id="lbl-acknowledgecard-serial_number">
                    {acknowledgeDevice.serial_number}
                  </TruncatedText>
                </StyledTooltip>
              </div>
              <div className="uptime-acknowledge-card-configuration-item">
                <div>
                  <AccessTimeIcon />
                </div>
                <div className="uptime-acknowledge-card-configuration-item-header">
                  {locale?.lastScanned}
                </div>
                <div className="uptime-acknowledge-card-configuration-item-content select-all-text" id="lbl-acknowledgecard-last_active">
                  {acknowledgeDevice.configuration.lastActive}
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12} >
            <div className="uptime-acknowledge-card-footer">
              <Button
                onClick={handleClickAcknowledge}
                id="btn-acknowledgecard-acknowledge"
                data-device_sn={acknowledgeDevice.serial_number}
                disabled={disableAcknowledgeButton}
              >
                {locale?.acknowledgeBtn}
              </Button>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </AcknowledgeCardStyle>
  );
};

export default AcknowledgeCard;
